import axios from 'axios'

export const fetchAllPaymentTemplates = () => axios.get('/paymenttemplates')
